export const DEFAULT_GIVEAWAY_STYLE = {
  color: "",
  emoji: "🎉",
  title: "🎁 New Offering: {prize}",
  description:
    "Click the {emoji} reaction to enter!\n\n**Ends:** {ends}\n**Hosted By:** {host}",
  footer: "{winners} winner(s) will be chosen",
  endedTitle: "🎁 Concluded Offering: {prize}",
  endedDescription: "**Winners:** {winnerList}\n**Hosted By:** {host}",
  endedColor: "#2b2d31",
  rerollTitle: "🔄 Rerolled Offering: {prize}",
  rerollColor: "#f1c40f",
  winMessage:
    "🎊 **Congratulations {winnerList}!** You have received the offering: **{prize}**!",
  rerollMessage:
    "✨ **Reroll Complete:** Congratulations {winnerList}! You are the new winner(s) of **{prize}**!",
  noWinnerMessage:
    '✦ **The offering for "{prize}" ended with no participants.**',
};
